import type { ReactNode } from 'react';

import type { ShowDialogOptions } from '@common/components/Notifications';
import type { TranslationsFunc } from '@lang';

export const EXPIRY_DIALOG_ID = 'basket-expiry';

export const buildExpiryDialog = (
  t: TranslationsFunc,
  cta: ReactNode,
  onDismiss: () => void
): [string, ShowDialogOptions] => [
  t('basket.expiredTitle'),
  {
    tone: 'danger',
    id: EXPIRY_DIALOG_ID,
    subtitle: t('basket.expiredDetail'),
    cta,
    onDismiss,
  },
];
